<template>
    <div>
        <h5 class="heading-1">
            <span>DADOS GERAIS</span>
        </h5>
        <app-k-v titulo="Data Solicitação" :md="md" :lg="lg" :xl="xl">
            <strong>{{ atesto.dtSolicitacaoDoAtesto | moment().format('DD/MM/YYYY HH:mm') }}</strong>
        </app-k-v>
        <app-k-v
            titulo="Contrato"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="atesto.contrato ? atesto.contrato.vcCodigoEstruturado : ''"
        ></app-k-v>
        <app-k-v
            titulo="Fornecedor"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="atesto.contrato ? atesto.contrato.fornecedor.nome: ''"
        ></app-k-v>
        <app-k-v titulo="Documento" :md="md" :lg="lg" :xl="xl" :dado="atesto.documento"></app-k-v>
        <app-k-v titulo="Valor" :md="md" :lg="lg" :xl="xl">
            <strong>{{ atesto.valor | currency }}</strong>
        </app-k-v>
        <app-k-v titulo="Situação" :md="md" :lg="lg" :xl="xl">
            <app-status :status="atesto.situacao ? atesto.situacao : ''"></app-status>
        </app-k-v>
        <app-k-v
            titulo="Motivo"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="atesto.vcMotivoNaoAtesto"
            v-if="atesto.codSituacao == 2"
        ></app-k-v>
    </div>
</template>

<script>
export default {
	props: {
		atesto: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			md: 3,
			lg: 2,
			xl: 1
		}
	}
}
</script>
